import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import GenericPolicyEn from './components/GenericPolicyEn';
import Where2ExitHe from './components/Where2ExitHe';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/genericPolicyEn" element={<GenericPolicyEn />} />
        <Route path="/where2exitHe" element={<Where2ExitHe />} />
        <Route path="/" element={<Navigate to="/genericPolicyEn" replace />} />
        <Route path="*" element={<Navigate to="/genericPolicyEn" replace />} />
      </Routes>
    </Router>
  );
};

export default App;